import { DvColumnType, DvToolbarAction } from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';
import { ToolbarActionsService } from '@features/vt-grid/services/toolbar-actions.service';
import { ColDef } from 'ag-grid-community';

@Injectable()
export class MileageHistoryGridService {
  private toolbarActionService = inject(ToolbarActionsService);

  colDefs: ColDef[] = [
    {
      field: 'MileageAdjustmentID',
      headerName: 'MileageHistoryGrid.MileageAdjustmentID',
      type: [DvColumnType.Id],
      initialHide: true,
    },
    {
      field: 'AdjustmentDate',
      headerName: 'MileageHistoryGrid.AdjustmentDate',
      type: [DvColumnType.DateTime],
    },
    {
      field: 'Mileage',
      headerName: 'Km',
      type: [DvColumnType.Number],
    },
    {
      field: 'Description',
      headerName: 'MileageHistoryGrid.Description',
      type: [DvColumnType.Text],
    },
  ];

  getGridActions(): DvToolbarAction[] {
    return [
      ...getStandardActionPreset(),
      {},
      {
        icon: 'delete',
        clickFn: this.toolbarActionService.deleteSelectedRow,
        disabled: true,
        tooltipKey: 'Grid.Delete',
      },
    ];
  }
}
